const discounts = {
	add_button: "Create discount",
	alerts: {
		discount_added: "Discount <strong>{{name}}</strong> added successfully!",
		discount_edited: "Discount <strong>{{name}}</strong> edited successfully!",
	},
	calculate_dialog: {
		discount: "Discount",
		margin: "Margin",
		name: "Product name",
		price_purchase: "Purchase price",
		price_recommended: "Recommended price",
		price_result: "Price",
	},
	create: {
		title: "Create discount",
	},
	delete_dialog: {
		description: "Are you sure you want to delete <strong>{{discount_label}}</strong>?",
		title: "Delete discount",
	},
	edit: {
		title: "Edit discount",
	},
	form: {
		active: "Active",
		all_debtors: "Everyone",
		all_products: "All products",
		amount: "Fixed discount amount",
		and: "And",
		applies_to: "Applies to",
		debtor: "Debtor",
		debtor_group: "Debtor group",
		debtor_type: "Target audience",
		discount_type: "Discount type",
		duration_undetermined: "Indefinite",
		if: "If",
		information: "Information",
		label: "Discount label",
		percentage: "Percentage",
		product: "Product",
		product_domain: "Domain name (product)",
		product_group: "Product group",
		product_group_apply_to: {
			each_product: "Each product in product group",
			product_group: "On the total price of the product group",
			title: "Apply Discount To",
		},
		single_debtor: "Single debtor",
		single_product: "Single product",
		then: "Then",
		till: "Until",
	},
	overview: "Discounts overview",
	status: {
		create: {
			success: "Discount added successfully!",
			unknown: "Discount cannot be added at the moment. Please try again later.",
		},
		delete: {
			success: "Discount deleted successfully!",
			unknown: "Discount cannot be deleted at the moment. Please try again later.",
		},
		edit: {
			success: "Discount edited successfully!",
			unknown: "Discount cannot be edited at the moment. Please try again later.",
		},
	},
	table: {
		debtor_type: "Target audience",
		details: "Details",
		id: "ID",
		label: "Label",
		product_type: "Applies to",
		table_items: {
			all_products: "All products",
			everyone: "Everyone",
		},
		type: "Discount type",
	},
	title: "Discounts",
};

export default discounts;
